/**
 * Available actions for an Announcement
 */
export enum AnnouncementActionTypes {
	Update = 'Update'
}

export interface ErrorAnnouncement {
	message: string;
}
